export class ApiError extends Error {
  constructor(status, message, code = "") {
    super(message);
    this.status = status;
    this.code = code;
  }
}

const OFFLINE_MESSAGE = "Can't reach the server. Is the backend running?";

// Fired after requests that can use AI credits, so the app can refresh what's left.
export const USAGE_EVENT = "plateo:usage";
const METERED = /^\/assistant\/(parse-job|jobs\/)/;

let onUnauthorized = null;

// Lets the auth layer sign the user out when any request reports an expired session.
export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

export async function request(path, { method = "GET", body, raw = false } = {}) {
  const isForm = body instanceof FormData;
  const headers = { Accept: "application/json" };
  if (body !== undefined && !isForm) headers["Content-Type"] = "application/json";

  let res;
  try {
    res = await fetch(`/api${path}`, {
      method,
      headers,
      credentials: "same-origin",
      body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, OFFLINE_MESSAGE);
  }

  if (res.status === 401 && !path.startsWith("/auth/")) onUnauthorized?.();
  if (method !== "GET" && METERED.test(path)) window.dispatchEvent(new Event(USAGE_EVENT));

  if (res.status === 204) return null;
  if (raw && res.ok) return res;

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    // The dev proxy answers with a non-JSON 5xx when the API is down.
    const message = data?.error || (res.status >= 500 && !data ? OFFLINE_MESSAGE : `Request failed (${res.status})`);
    throw new ApiError(res.status, message, data?.code);
  }
  return data;
}
